import moment from 'moment';

export const convertDateToDDMMYY = (date: Date) => {
    return moment(date).format('DD-MM-YYYY à HH:mm');
};

export const checkDateIsNull = (date: Date, message = 'Aucune date') => (date === null ? message : convertDateToDDMMYY(date));
